var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVinFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01598 15.5455H4.60689V18.1364C4.60689 18.6133 4.99357 19 5.47053 19H16.9857C17.4626 19 17.8493 18.6133 17.8493 18.1364V4.31818C17.8493 3.84122 17.4626 3.45455 16.9857 3.45455H14.3948V0.863636C14.3948 0.386679 14.0081 0 13.5311 0H2.01598C1.53902 0 1.15234 0.386679 1.15234 0.863636V14.6818C1.15234 15.1588 1.53902 15.5455 2.01598 15.5455ZM16.122 17.2727H6.33416V5.18182H16.122V17.2727ZM2.87962 1.72727H12.6675V3.45455H5.47053C4.99357 3.45455 4.60689 3.84122 4.60689 4.31818V13.8182H2.87962V1.72727Z",
    fill: "#0061ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92418 6.91016C8.44723 6.91016 8.06055 7.29684 8.06055 7.77379C8.06055 8.25075 8.44723 8.63743 8.92418 8.63743H13.5302C14.0072 8.63743 14.3939 8.25075 14.3939 7.77379C14.3939 7.29684 14.0072 6.91016 13.5302 6.91016H8.92418Z",
    fill: "#0061ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5302 10.3633H8.92418C8.44723 10.3633 8.06055 10.75 8.06055 11.2269C8.06055 11.7039 8.44723 12.0906 8.92418 12.0906H13.5302C14.0072 12.0906 14.3939 11.7039 14.3939 11.2269C14.3939 10.75 14.0072 10.3633 13.5302 10.3633Z",
    fill: "#0061ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5302 13.8164H8.92418C8.44723 13.8164 8.06055 14.2031 8.06055 14.68C8.06055 15.157 8.44723 15.5437 8.92418 15.5437H13.5302C14.0072 15.5437 14.3939 15.157 14.3939 14.68C14.3939 14.2031 14.0072 13.8164 13.5302 13.8164Z",
    fill: "#0061ED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinFile);
export default ForwardRef;